export type CanvasCoordinates = {
  x: number;
  y: number;
  width: number;
  height: number;
  quadrantId: number;
  page?: number;
};

export type PercentageCoordinates = {
  x: number;
  y: number;
  width: number;
  height: number;
  quadrantId: number;
  page?: number;
};

export type OriginalDimensions = {
  width: number;
  height: number;
};

export const convertCanvasToPercentages = (
  canvasCoords: CanvasCoordinates,
  originalDimensions: OriginalDimensions,
): PercentageCoordinates => {
  const { width: originalWidth, height: originalHeight } = originalDimensions;

  const result = {
    x: (canvasCoords.x / originalWidth) * 100,
    y: (canvasCoords.y / originalHeight) * 100,
    width: (canvasCoords.width / originalWidth) * 100,
    height: (canvasCoords.height / originalHeight) * 100,
    quadrantId: canvasCoords.quadrantId,
    page: canvasCoords.page,
  };

  return result;
};

export const convertPercentagesToCanvas = (
  percentCoords: PercentageCoordinates,
  originalDimensions: OriginalDimensions,
): CanvasCoordinates => {
  const { width: originalWidth, height: originalHeight } = originalDimensions;

  return {
    x: (percentCoords.x / 100) * originalWidth,
    y: (percentCoords.y / 100) * originalHeight,
    width: (percentCoords.width / 100) * originalWidth,
    height: (percentCoords.height / 100) * originalHeight,
    quadrantId: percentCoords.quadrantId,
    page: percentCoords.page,
  };
};
